import { FC } from 'react'

import { Shipment } from 'src/types/shipments'

import LabelAndInfo from '../LabelAndInfo'

import { multilineAddress } from '../../../utils'

export type ShipmentAddressRowProps = {
  shippedToRegistrant: boolean
  address: Shipment['address']
}
const ShipmentAddressRow: FC<ShipmentAddressRowProps> = ({
  shippedToRegistrant,
  address,
}) => {
  const { node: rows } = multilineAddress({ address, includeCountry: true })

  const info = shippedToRegistrant ? rows : address.name

  return <LabelAndInfo info={info} label="Shipping to" />
}

export default ShipmentAddressRow
